import { createContext } from 'react'

const CssNamespaceContext = createContext(null)
const CssNamespaceProvider = CssNamespaceContext.Provider

export { CssNamespaceContext, CssNamespaceProvider }
